<template>
    <div>
        <div v-if="preloader">
            <template>
                <bubble-loader />
            </template>
        </div>

        <div v-else>
            <v-card height="64px" width="100%"
                class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
                style="position: fixed; z-index: 200; top: 0; width: 98%; padding-top: 16px;">
                <v-card-title class="pl-0 ml-0">
                    <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.push('/campaign')">
                        Campaigns
                    </p>
                    <v-icon class="breadcrumb-arrow-unselected"
                        style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                    <p class="breadcrumb-text-unselected underline-on-hover cursor" @click="$router.back()">
                        {{ campaignName }}
                    </p>
                    <v-icon class="breadcrumb-arrow-unselected"
                        style="margin-top: 6px !important">mdi-chevron-right</v-icon>
                    <p class="breadcrumb-text" style="margin-top: 2px">Interview History</p>
                    <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important">mdi-chevron-down</v-icon>
                </v-card-title>
                <UserNavMenu/>
            </v-card>

            <div class="ma-8 mt-16">
                <div class="d-flex justify-space-between align-center mb-6">
                    <h2 class="text-h5">Interview History</h2>
                    <v-btn 
                        rounded 
                        depressed
                        class="btn elevation-0  outline-btn"
                        @click="toggleExpandAll"
                    >
                        {{ allExpanded ? 'Collapse All' : 'Expand All' }}
                    </v-btn>
                </div>
                   <v-card
                      class="assessment-details d-flex flex-column rounded-xl gap-12 pa-4 fs-12 mb-3"
                    >
                      <v-row class="pt-0 pb-0 px-4 mt-0">
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Canditate name </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                
                              <span class="pr-2">-</span>  {{campaignUserData.personalInfo.firstName}} {{campaignUserData.personalInfo.lastName}}
                            
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="5" class="pa-0">
                              <span> Email Id </span>
                            </v-col>

                            <v-col cols="7" class="pa-0">
                              <div>
                                
                               <span class="pr-2">-</span> {{campaignUserData.personalInfo.contactInfo.email}}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Phone No </span>
                            </v-col>

                            <v-col cols="8" class="pa-0">
                              <div>
                                
                             <span class="pr-2">-</span>   {{ campaignUserData.personalInfo.contactInfo.phoneNumber }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row class="pa-4 mt-0">
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Preferred Location </span>
                            </v-col>

                            <v-col cols="8" class="pa-0">
                              <div>
                               <span class="pr-2">-</span> {{campaignUserData.teachingInterests.schools}}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="5" class="pa-0">
                              <span> Preferred Job Role </span>
                            </v-col>
                            <v-col cols="7" class="pa-0">
                              <div class="d-flex align-center">
                                <span class="pr-2">-</span>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span
                                      v-bind="attrs"
                                      v-on="on"
                                      class="job-role-ellipsis"
                                    >
                                      {{ campaignUserData.teachingInterests.jobRole.HRIS_unique_role }}
                                    </span>
                                  </template>
                                  <span>{{ campaignUserData.teachingInterests.jobRole.HRIS_unique_role }}</span>
                                </v-tooltip>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Preferred Subjects </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                
                            <span class="pr-2">-</span>   {{campaignUserData.teachingInterests.subjects.join()}}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row class="pb-4 px-4 pt-0 mt-0">
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Rounds Attempted </span>
                            </v-col>

                            <v-col cols="8" class="pa-0">
                              <div>
                              
                            <span class="pr-2">-</span>   {{ campaignUserData.round }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="5" class="pa-0">
                              <span>Campaign Start Date </span>
                            </v-col>

                            <v-col cols="7" class="pa-0">
                              <div>
                             <span class="pr-2">-</span>   {{ changeDateFormat(startDate) }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row>
                            <v-col cols="4" class="pa-0">
                              <span> Campaign End Date </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                            <span class="pr-2">-</span>  <span>  {{ changeDateFormat(endDate) }}</span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                <div v-for="(roundData, round) in interviewRounds" :key="round" class="mb-4">
                    <v-expansion-panels 
                        v-model="expandedPanels[round]"
                        style="border: 1px solid #e0e0e0; border-radius: 8px"
                    >
                        <v-expansion-panel>
                            <v-expansion-panel-header class="py-2">
                                <template v-slot:default="{ open }">
                                    <div class="d-flex align-center">
                                        <span class="text-body-1 font-weight-medium">Round {{ round }}</span>
                                    </div>
                                </template>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content v-scrollable-cursor class="interview-history-content">
                                <div class="py-4 history-timeline">
                                    <div v-for="(status, index) in getRoundTimeline(roundData)" :key="status.__key || index">
                                        <div
                                            class="history-node"
                                            :style="{ marginLeft: `${status.__level * 2.2}rem`,
                                              'margin-top': '0px'
                                             }"
                                        >
                                            <!-- Vertical trunk lines bridging this node to items further down
                                                 the chain. Each entry is the anchor level whose child column
                                                 the line lands on (see getConnectorMargin). -->
                                            <div
                                                v-for="trunk in (status.__trunks || [])"
                                                :key="`trunk-${trunk}`"
                                                class="history-trunk"
                                                :style="{ left: getConnectorMargin(status.__level, trunk) }"
                                            ></div>
                                            <div class="d-flex align-end" :style="status.__level > 0 ? 'position: relative; left: -0.9375rem; margin-top:-0.15rem' : ''">
                                                <img
                                                    v-if="status.__level > 0 && !status.__noArrow"
                                                    src="../assets/angle-arrow.svg"
                                                    class=""
                                                    :style="{
                                                        // marginLeft: index > 0 ? '60px' : '',
                                                        position: 'relative',
                                                        top: '-10px'

                                                    }"

                                                    alt="arrow"
                                                />
                                                <!-- Reserve the elbow's width when it's hidden (later block
                                                     headers under a slot) so the heading stays aligned with the
                                                     first block instead of sliding left onto the slot level. -->
                                                <div
                                                    v-else-if="status.__level > 0 && status.__noArrow"
                                                    style="width: 37px; flex: 0 0 37px;"
                                                ></div>
                                                <span
                                                    class="text-body-1 font-weight-medium"
                                                    :class="getStatusColor(status.status)"
                                                    style="left: -23px"
                                                >
                                                    {{formatStatus(status.status, round)  }}
                                                </span>
                                            </div>

                                                <div
                                                    class="history-columns mt-2"
                                                    :class="status.__level > 0 ? `ml-1` : ''"
                                                >
                                                <v-row class="history-row">
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2" v-if="status.status == 'DELEGATED'">
                                                    <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">Delegated By</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status?.delegatedByName || status?.delegatedFrom }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2" v-if="status.status == 'DELEGATED'">
                                                    <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">Delegated to</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status?.delegatedToName || status?.delegatedTo }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2">
                                                    <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">{{status.status == 'DELEGATED' ? "Date And Time" :  ["SCHEDULED","RESCHEDULED","COMPLETED"].includes(status.status) ? `Interview ${status.status[0]}${status.status.slice(1).toLowerCase()} on` : status.status == 'SLOT_REQUESTED' ? 'Requested on' : status.status == 'SLOT_RESCHEDULED' ? 'Slot Rescheduled on' : 'Action Taken on'}}</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ formatDate(status.time) }}</span>
                                                    </div>
                                                    </v-col>
                                                         <v-col cols="4" v-if="['ACCEPTED', 'DECLINED', 'DELETED', 'CONFIRMED'].includes(status.status)">
                                                        <div class="d-flex align-center " >
                                                        <span class="text-body-2 ">Action Taken By</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status.actionTakenBy}}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2" v-if="['SLOT_REQUESTED', 'SLOT_RESCHEDULED', 'SLOT_ACCEPTED', 'SLOT_REJECTED'].includes(status.status) && status.actionTakenBy">
                                                        <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">{{ status.status === 'SLOT_REQUESTED' ? 'Requested By' : status.status === 'SLOT_RESCHEDULED' ? 'Rescheduled By' : 'Action Taken By' }}</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status.actionTakenBy }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2" v-if="['SLOT_REQUESTED', 'SLOT_RESCHEDULED'].includes(status.status) && status.approverName">
                                                        <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">Approver</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status.approverName }}{{ status.approverEmail ? ` (${status.approverEmail})` : '' }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" v-if="['ACCEPTED'].includes(status.status)">
                                                        <div class="d-flex align-center " >
                                                        <span class="text-body-2 ">Interviewer Response</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status.status == "ACCEPTED" ? 'Yes': 'No' }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col v-if="status.descisionMaker" cols="4" class="pl-4 pt-1 pb-2">
                                                           <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">
                                                            {{ status.status === 'SEND_TO_HIRING_MANAGER' ? 'Action Taken By' : status.descisionMaker ? 'Decision Maker' : `${status.status[0]}${status.status.slice(1).toLowerCase()} By` }}
                                                        </span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status.descisionMaker || status.actionTakenBy }}</span>
                                                    </div>
                                                    <div class="d-flex align-center" v-if="status.hris_unique_role">
                                                            <span class="text-body-2">
                                                                HRIS Unique Role
                                                            </span>
                                                            <span class="mx-4">-</span>
                                                            <span class="text-body-2">{{status.hris_unique_role }}</span>
                                                        </div>
                                                    </v-col>
                                                    <v-col v-if="status.descisionMaker" cols="4" class="pl-4 pt-1 pb-2">
                                                        <div class="d-flex align-center ">
                                                        <span class="text-body-2 ">
                                                            Hiring Manager Name 
                                                            
                                                        </span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{status.hiringManagerName }}</span>
                                                        </div>
                                                        <!-- <div class="d-flex align-center">
                                                            <span class="text-body-2">
                                                                Remarks
                                                            </span>
                                                            <span class="mx-4">-</span>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span 
                                                                        class="text-body-2 text-truncate" 
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        style="max-width: 200px; display: inline-block;"
                                                                    >
                                                                        {{ cleanedRemark(status?.remark) }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ cleanedRemark(status?.remark) }}</span>
                                                            </v-tooltip>
                                                        </div> -->
                                                    </v-col>
                                                    <!-- <v-col v-if="status?.remark" cols="4" class="pl-4 pt-1 pb-2">
                                                        <div class="d-flex align-center">
                                                            <span class="text-body-2">
                                                                Remarks
                                                            </span>
                                                            <span class="mx-4">-</span>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <span 
                                                                        class="text-body-2 text-truncate" 
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        style="max-width: 200px; display: inline-block;"
                                                                    >
                                                                        {{ cleanedRemark(status?.remark) }}
                                                                    </span>
                                                                </template>
                                                                <span>{{ cleanedRemark(status?.remark) }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-col> -->
                                                    <!-- Full-width so the (often long) designation uses the whole
                                                         row instead of wrapping inside the narrow date column. -->
                                                    <v-col cols="12" class="pl-4 pt-1 pb-2" v-if="status.descisionMaker && status.hiringManagerDesignation">
                                                        <div class="d-flex align-center">
                                                        <span class="text-body-2 text-no-wrap">Hiring Manager Designation</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2 mr-4">{{ status.hiringManagerDesignation }}</span>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4" class="pl-4 pt-1 pb-2" v-if="['SCHEDULED', 'RESCHEDULED', 'COMPLETED'].includes(status.status) && status.actionTakenBy">
                                                        <div class="d-flex align-center ">
                                                            <span class="text-body-2">{{ status.status === 'RESCHEDULED' ? 'Rescheduled By' : status.status === 'COMPLETED' ? 'Action Taken By' : 'Scheduled By' }}</span>
                                                            <span class="mx-4">-</span>
                                                            <span class="text-body-2">{{ status.actionTakenBy }}</span>
                                                        </div>
                                                    </v-col>
                                                    <v-col  class="pl-4 pt-1 pb-2" cols="4" v-if="status.actionTakenBy && status?.interviewerEmails && !['CONFIRMED', 'ACCEPTED', 'DECLINED'].includes(status.status)">
                                                            <div class="d-flex align-center">
                                                        <span class="text-body-2">
                                                            Interviewers
                                                        </span>
                                                        <span class="mx-4">-</span>
                                                         <v-tooltip bottom v-if="status.interviewerEmails.length == 1">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span 
                                                            class="text-body-2"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            >
                                                            {{ status.interviewerEmails.join(", ") }}
                                                            </span>
                                                        </template>
                                                        <span>{{ status.interviewerEmails.join(", ") }}</span>
                                                        </v-tooltip>
                                                         <div v-else class="my-custom-tooltip">
                                                            <v-tooltip right >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <span  v-bind="attrs" v-on="on" >{{ status.interviewerEmails[0] }} + {{ status.interviewerEmails.length -1 }}</span>
                                                            </template>
                                                            <span  class="custom-tooltip" v-for="mail in status.interviewerEmails">{{ mail }}</span>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                    </v-col>
                                                    <v-col cols="4"  class="pl-4 pt-1 pb-2" v-if="status?.hiringManagerEmail">
                                                          <div class="d-flex align-center ">
                                                        <span class="text-body-2">Hiring Manager Name</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status?.hiringManagerName }}</span>
                                                    </div>
                                                    </v-col> 
                                    
                                                    <v-col cols="12"  class="pl-4 pt-1 pb-2" v-if="status?.hiringManagerEmail">
                                                        <div class="d-flex align-center " >
                                                        <span class="text-body-2 text-no-wrap">Hiring Manager Designation</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ status?.hiringManagerDesignation }}</span>
                                                    </div>
                                                    </v-col>
                                                       <v-col cols="12"  class="pl-4 pt-1 pb-2" v-if="['DELEGATED', 'DELETED'].includes(status.status.toUpperCase()) || (status.status === 'SLOT_REJECTED' && status.comments)">
                                                        <div class="d-flex align-center " >
                                                        <span class="text-body-2">Comments</span>
                                                        <span class="mx-4">-</span>
                                                        <span class="text-body-2">{{ cleanedRemark(status.comments) }}</span>
                                                    </div>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                              <v-divider v-if="status.showBar && !status?.history"   class="my-6" :style="{ marginLeft:  getDividerMargin(status),
                                             }"></v-divider>
                                        </div>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import AuthService from "../services/AuthService";
import CampaignController from "@/controllers/CampaignController";
import UserNavMenu from "@/components/UserNavMenu.vue";

export default {
    components: {
        BubbleLoader,
        UserNavMenu
    },
    // Toggles `is-scrollable` on the element whenever its content overflows
    // horizontally, so the grab cursor only appears when there's actually
    // something to scroll (the scrollbar itself is hidden via CSS).
    directives: {
        scrollableCursor: {
            inserted(el) {
                const update = () => {
                    el.classList.toggle('is-scrollable', el.scrollWidth > el.clientWidth + 1);
                };
                el.__scrollableUpdate = update;
                window.addEventListener('resize', update);
                update();
                // Re-measure once the expansion-panel open animation has settled.
                setTimeout(update, 350);
            },
            componentUpdated(el) {
                if (el.__scrollableUpdate) el.__scrollableUpdate();
            },
            unbind(el) {
                if (el.__scrollableUpdate) {
                    window.removeEventListener('resize', el.__scrollableUpdate);
                    delete el.__scrollableUpdate;
                }
            }
        }
    },
    data() {
        return {
            preloader: true,
            campaignId: '',
            userId: '',
            campaignName: "",
            expandedPanels: {},
            allExpanded: true,
            notificationDialog: false,
            interviewRounds: {},
            campaignUserData: {},
            viewType: 'candidate',
            startDate: '', 
            endDate: ''
        }
    },

    async mounted() {
        this.viewType = this.$route.query?.viewType || 'candidate';
        this.campaignId = this.$route.query.campaignId;
        this.userId = this.$route.query.userId;
         await this.fetchCampaignAudience();
        if(this.viewType == 'interviewer'){
          await this.fetchInterviewerHistory({interviewerEmail: this.$route.query.interviewerEmail, userId: this.userId})  
        }else{
            await this.fetchInterviewerHistoryV2({interviewerEmail: this.$route.query.interviewerEmail, userId: this.userId})
        }

        this.preloader = false;
        Object.keys(this.interviewRounds).forEach(round => {
                this.$set(this.expandedPanels, round, 0);
        });
    },
    
    methods: {
        // Left offset of a vertical trunk line (or divider), relative to a node
        // indented by `level * 2.2rem`. `anchor` is the level of the parent the
        // line hangs from: it lands on that parent's child-elbow column
        // (anchor * 2.2rem + 1.2625rem from the round's left edge) — exactly where
        // the elbow arrows of level `anchor + 1` items sit, so trunks and elbows
        // always line up. anchor 0 reproduces the legacy flat-layout behavior.
        // NOTE: 1.2625rem = 2.2rem - 0.9375rem, where -0.9375rem is the heading
        // row's `left` (which carries both the arrow and its heading). Keep these
        // in sync if the heading row's horizontal offset changes.
        getConnectorMargin(level, anchor = 0) {
            return `${1.2625 + anchor * 2.2 - level * 2.2}rem`;
        },
        // Dividers separate whole interview blocks, so they all start flush with
        // those blocks' left extremity (`__dividerLeft`, an absolute offset from
        // the round's left edge) regardless of how deep the node that happens to
        // carry the divider is nested — the node's own `__anchor` would step the
        // line right by one indent (2.2rem) for a divider closing a nested chain.
        getDividerMargin(status) {
            const left = typeof status.__dividerLeft === 'number' ? status.__dividerLeft : 0;
            return `${left - status.__level * 2.2}rem`;
        },
        changeDateFormat(dateString) {
            // Input: YYYY-MM-DD -> Output: DD/MM/YYYY
            if (!dateString || typeof dateString !== 'string') {
                return ''
            }

            const parts = dateString.split('-')
            if (parts.length !== 3) {
                return ''
            }

            const [year, month, day] = parts
            if (!year || !month || !day) {
                return ''
            }

            return `${day}/${month}/${year}`
        },
          cleanedRemark(text = "") {
            return text?.replace(/<[^>]*>|[\n\r\t]|[^\w\s.,!?-]/g, ' ').replace(/\s+/g, ' ').trim() || '';
        },
        async fetchInterviewerHistory(user) {
            let query = `?email=${user.interviewerEmail}&userId=${user.userId}`
            try {
                const res = await CampaignController.fetchInterviewerHistory(query)
                this.interviewRounds = res.data.result
            } catch (error) {
                console.log(error)
            }
        },
         async fetchInterviewerHistoryV2(user) {
            // let query = `?email=${user.interviewerEmail}&userId=${user.userId}`
             let query = `?userId=${user.userId}`
            try {
                const res = await CampaignController.fetchInterviewerHistoryV2(query)
                
                if(res.status == 200 && res.data.flag ){
                    this.interviewRounds = res.data.result
                }
            } catch (error) {
                console.log(error)
            }
        },
        async fetchCampaignAudience() {
            try {
                const query = `?campaignId=${this.campaignId}&itemsPerPage=1&page=1&userId=${this.userId}`;
                const audienceData = await CampaignController.getCampaignAudience(query);
                this.campaignUserData = audienceData.result.users[0];
                this.campaignName = audienceData.result.campaignName;
                this.startDate = audienceData.result.campaignStartDate
                this.endDate = audienceData.result.campaingEndDate
                
                // Update interview rounds based on the interview status history
                if (this.campaignUserData?.interviewStatusHistory && this.viewType == 'candidate') {
                    this.interviewRounds = this.campaignUserData.interviewStatusHistory;                
                }

            } catch (error) {
                console.error('Error fetching campaign audience:', error);
            }
        },

        logout() {
            AuthService.logout();
            this.$router.push("/login");
        },
        
        toggleExpandAll() {
            this.allExpanded = !this.allExpanded;
            
            // Set all panels to match the allExpanded state
            Object.keys(this.interviewRounds).forEach(round => {
                this.$set(this.expandedPanels, round, this.allExpanded ? 0 : null);
            });
        },

        formatDate(dateString) {
            return new Date(dateString).toLocaleString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        formatStatus(status = "", round) {
            if(status == 'ACCEPT_AND_SCHEDULE_NEXT_ROUND'){
                let updatedStatus = "Accepted at R"+`${round}`;
                return updatedStatus
            }
            let formattedStatus =  status?.split('_').map(word => 
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            ).join(' ');
            
            if(['Accepted', 'Rejected'].includes(formattedStatus)){
                formattedStatus = `${formattedStatus}`
            }
            return formattedStatus
        },

     getStatusColor(status) {
            const colorMap = {
                'SLOT_REQUESTED': 'blue--text',
                'SLOT_RESCHEDULED': 'blue--text',
                'SLOT_ACCEPTED': 'success--text',
                'SLOT_REJECTED': 'error-01--text',
                'SLOT_DECLINED': 'error-01--text',
                'RESCHEDULED': 'blue--text',
                'SCHEDULED': 'blue--text',
                'SEND_TO_HIRING_MANAGER': 'purple--text',
                'ACCEPT_AND_SCHEDULE_NEXT_ROUND': 'indigo--text',
                'NOTIFY_HR_TO_SCHEDULE_NEXT_ROUND': 'indigo--text',
                'ACCEPTED': 'success--text',
                'REJECTED': 'error-01--text',
                'ONHOLD': 'warning--text',
                'ON HOLD': 'warning--text',
                'COMPLETED':'blue--text', 
                'CONFIRMED':'purple--text', 
                'DELEGATED': 'warning--text',
                'ACCEPTED' :'purple--text',
                'DECLINED' : 'error-01--text',
                'DELETED': 'warning--text',
                'SCHEDULED': 'blue--text',
                'FEEDBACK_SUBMITTED': 'magenta--text',
                'INTERVIEW_COMPLETED':  'blue--text',
                
                
            };
            return  colorMap[status.toUpperCase()] || '';
        },

        getRoundTimeline(roundData) {
            if (!Array.isArray(roundData)) return [];
            if (this.viewType === 'interviewer') {
                return roundData.map((status, index) => ({
                    ...status,
                    __level: index,
                    __key: `s-${index}`,
                    showLine: false,
                    showBar: false
                }));
            }

            // Slot-approval flow. When the round carries the slot events, they wrap
            // the interview history: SLOT_REQUESTED / SLOT_RESCHEDULED sit at the
            // outer level, SLOT_ACCEPTED / SLOT_REJECTED one level deeper, and the
            // existing interview history nests under the accepted/rejected slot
            // (via its `history` key), rendered two levels deep by the same builder.
            const slotParentStatuses = new Set(['SLOT_REQUESTED', 'SLOT_RESCHEDULED', 'SLOT_ACCEPTED', 'SLOT_REJECTED', 'SLOT_DECLINED']);
            const hasSlotFlow = roundData.some(s => slotParentStatuses.has(s.status));

            if (hasSlotFlow) {
                const timeline = [];
                const decisionStatuses = new Set(['SLOT_ACCEPTED', 'SLOT_REJECTED', 'SLOT_DECLINED']);
                roundData.forEach((status, statusIndex) => {
                    const isDecision = decisionStatuses.has(status.status);
                    const level = isDecision ? 1 : 0; // request/reschedule outer, accept/reject one deeper
                    timeline.push({
                        ...status,
                        __level: level,
                        __anchor: 0,
                        __trunks: [],
                        __key: `slot-${statusIndex}`,
                        // The slot chain reads as one connected flow — no dividers
                        // between its events; the nested interview history brings
                        // its own block dividers.
                        showBar: false,
                    });
                    // The accepted/rejected slot owns the existing interview history,
                    // rendered one level deeper than the slot decision itself.
                    if (isDecision && Array.isArray(status.history)) {
                        timeline.push(...this.buildInterviewTimeline(status.history, level + 1, `slot-${statusIndex}`));
                    }
                });
                return timeline;
            }

            // No slot flow (legacy data / interviewer-scheduled rounds): render the
            // interview history at the outer level, exactly as before.
            return this.buildInterviewTimeline(roundData, 0, 's');
        },

        // Builds the interview-history timeline (SCHEDULED / RESCHEDULED / COMPLETED
        // / SEND_TO_HIRING_MANAGER and their nested `history` groups). `baseLevel`
        // offsets every node's indentation so the same structure can be rendered at
        // the outer level (baseLevel 0) or nested under a slot decision (baseLevel 2).
        buildInterviewTimeline(roundData, baseLevel = 0, keyPrefix = 's') {
            if (!Array.isArray(roundData)) return [];

            const timeline = [];
            const outerStatuses = new Set(['SCHEDULED', 'RESCHEDULED', 'COMPLETED', 'SEND_TO_HIRING_MANAGER']);
            let postCompleted = false;
            let postCompletedLevel = baseLevel + 1;
            // In the slot flow, only the FIRST block header under the slot decision
            // keeps its elbow arrow (the entry point into the nested history). The
            // rest at this level — Completed, Send to HM, further Scheduled/Rescheduled
            // — render without one.
            let blockHeaderSeen = false;

            // Trunk lines land on the parent's child-elbow column: outer blocks hang
            // from the slot decision (baseLevel - 1) when nested; group children hang
            // from their outer item (its level). anchor 0 == legacy flat layout.
            const outerAnchor = Math.max(baseLevel - 1, 0);

            // Where every divider in this timeline starts, as an absolute offset
            // from the round's left edge: flush with the STATUS NAME of the block
            // headers it separates. A nested header (baseLevel > 0) has its heading
            // row shifted -0.9375rem and then reserves 2.3125rem (37px) for the
            // elbow arrow before the name, so the name sits 1.375rem past the
            // node's indent; an outermost header has neither, so it sits at 0.
            // Keep these in sync with the heading row in the template — its `left`
            // and the arrow / no-arrow placeholder width.
            const dividerLeft = baseLevel > 0 ? baseLevel * 2.2 + 1.375 : 0;

            roundData.forEach((status, statusIndex) => {
                const isOuter = outerStatuses.has(status.status);
                const hasHistory = Array.isArray(status.history);
                const roundLastItem = roundData.length - 1 == statusIndex

                if (isOuter) {
                    // Only the first block header under a slot decision shows the elbow
                    // arrow; later ones at this level (Completed, Send to HM, …) don't.
                    const suppressArrow = baseLevel > 0 && blockHeaderSeen;
                    blockHeaderSeen = true;
                    timeline.push({
                        ...status,
                        __level: baseLevel,
                        __anchor: outerAnchor,
                        __dividerLeft: dividerLeft,
                        // Block headers carry NO trunk — they aren't joined into one
                        // continuous grouping line at the slot level.
                        __trunks: [],
                        __noArrow: suppressArrow,
                        __key: `${keyPrefix}-${statusIndex}`,
                        showBar: status.status !== 'SEND_TO_HIRING_MANAGER' && !roundLastItem
                    });

                    if (hasHistory) {
                        status.history.forEach((group, groupIndex) => {
                            if (!Array.isArray(group)) return;
                            let isLastHistory = status.history.length -1 !== groupIndex
                            group.forEach((item, itemIndex) => {
                                let isLastItem = group.length-1 == itemIndex
                                timeline.push({
                                    ...item,
                                    __level: baseLevel + itemIndex + 1,
                                    __anchor: baseLevel,
                                    __dividerLeft: dividerLeft,
                                    // Non-last groups carry the trunk down to the next
                                    // group's elbow (the outer item's child column).
                                    __trunks: isLastHistory ? [baseLevel] : [],
                                    __key: `${keyPrefix}-${statusIndex}-g-${groupIndex}-i-${itemIndex}`,
                                     showBar: !isLastHistory && isLastItem
                                });
                            });
                        });
                    }

                    postCompleted = (status.status === 'COMPLETED' ||  status.status == 'SEND_TO_HIRING_MANAGER') && !hasHistory;
                    postCompletedLevel = baseLevel + 1;
                    return;
                }

                if (postCompleted) {
                    const level = postCompletedLevel;
                    timeline.push({
                        ...status,
                        __level: level,
                        __anchor: level - 1,
                        __dividerLeft: dividerLeft,
                        __trunks: [],
                        __key: `${keyPrefix}-pc-${statusIndex}`,
                        showBar: status.status !== 'SEND_TO_HIRING_MANAGER' && !roundLastItem

                    });

                    if (hasHistory) {
                        status.history.forEach((group, groupIndex) => {
                            let isLastHistory = status.history.length -1 !== groupIndex
                            if (!Array.isArray(group)) return;
                            group.forEach((item, itemIndex) => {
                                let isLastItem = group.length-1 == itemIndex
                                timeline.push({
                                    ...item,
                                    __level: level + itemIndex + 1,
                                    __anchor: level,
                                    __dividerLeft: dividerLeft,
                                    __trunks: isLastHistory ? [level] : [],
                                    __key: `${keyPrefix}-pc-${statusIndex}-g-${groupIndex}-i-${itemIndex}`,
                                    showBar: !isLastHistory && isLastItem
                                });
                            });
                        });
                    }

                    postCompletedLevel = level + 1;
                    return;
                }

                timeline.push({
                    ...status,
                    __level: baseLevel,
                    __anchor: outerAnchor,
                    __dividerLeft: dividerLeft,
                    __trunks: [],
                    __key: `${keyPrefix}-${statusIndex}`,
                    showbar: status.status !== 'SEND_TO_HIRING_MANAGER' && !roundLastItem
                });
            });

            // NOTE: block headers are intentionally NOT joined by a continuous
            // trunk at the slot-decision level — the interview-history blocks read
            // as separate items under the slot, with grouping lines only inside each
            // block's own Scheduled/Rescheduled sub-history.
            return timeline;
        },

        
    },
    
    watch: {
        expandedPanels: {
            handler() {
                // Check if all panels are expanded
                const allRounds = Object.keys(this.interviewRounds);
                this.allExpanded = allRounds.every(round => this.expandedPanels[round] === 0);
            },
            deep: true
        }
    }
}
</script>

<style scoped>
.repCard {
    margin: 80px 12px 0 32px;
}

.connector-line-1 {
    width: 45px;
    margin-right: 5px;
    height: 1px;
    background-color: #A3A3A3;
    position: relative;
}

.connector-line-2 {
    width: 115px;
    margin-right: 5px;
    height: 1px;
    background-color: #A3A3A3;
    position: relative;
}

.btn.outline-btn-ih {
    border: 1px solid var(--v-primary-base);
    color: var(--blue-01) !important;
}

.breadcrumb-text-unselected {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
}

.breadcrumb-text {
    color: var(--v-primary-base);
    font-size: 14px;
}

.breadcrumb-arrow-unselected {
    color: rgba(0, 0, 0, 0.6);
}

.breadcrumb-arrow {
    color: var(--v-primary-base);
}

.underline-on-hover:hover {
    text-decoration: underline;
}

.cursor {
    cursor: pointer;
}

/* panel styles */
.v-expansion-panels {
    border-radius: 8px !important;
    box-shadow: none !important; 
    border: 1px solid #e0e0e0 !important;
}

.v-expansion-panel {
    background-color: #ffffff !important;
    margin-bottom: 0 !important;
    position: relative !important;
}

.v-expansion-panel::before {
    box-shadow: none !important;
}

.v-expansion-panel-header {
    padding: 16px 24px !important;
    min-height: 64px !important;
}

.v-expansion-panel-header .font-weight-medium {
    font-size: 16px !important;
}

/* Style for the expanded state */
.v-expansion-panel--active {
    border-bottom: 1px solid #e0e0e0 !important;
}

.v-expansion-panel--active .v-expansion-panel-header {
    border-bottom: 1px solid #e0e0e0 !important;
}

.v-expansion-panel-header:hover {
    background-color: #f5f5f5 !important;
}

.repCard h2 {
    font-size: 20px;
}

.interview-history-span {
    width: 190px;
}

.history-node {
    position: relative;
}

.interview-history-content {
    overflow-x: auto;
    overflow-y: hidden;
    /* Hide the horizontal scrollbar while keeping the area scrollable. */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE / old Edge */
}

.interview-history-content::-webkit-scrollbar {
    display: none; /* Chrome / Safari / Edge */
}

/* Hint that the (scrollbar-less) area can still be scrolled — only added by the
   v-scrollable-cursor directive when the content actually overflows. */
.interview-history-content.is-scrollable {
    cursor: grab;
}

.interview-history-content.is-scrollable:active {
    cursor: grabbing;
}

/* The panel body scrolls horizontally, so a plain block child would only ever be
   as wide as the VISIBLE area — dividers stopped at the viewport edge instead of
   the content's, and slid out of place as soon as the panel was scrolled right.
   Sizing the wrapper to its widest row makes every node (and so every divider)
   span the full scrollable width; min-width keeps it filling the panel when the
   content is narrower than the visible area. */
.history-timeline {
    width: max-content;
    min-width: 100%;
}

.history-columns {
    width: max-content;
}

/* The row is a Vuetify v-row (already display:flex). Keep it a single, nowrap,
   content-width line laid out left-to-right; the area scrolls horizontally. */
.history-row {
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    width: max-content;
    margin: 0;
    padding-left: 1rem;
    /* One uniform gap between every field (replaces the old per-field mr-6). */
    column-gap: 2rem;
}

/* ROOT-CAUSE FIX for the overlap: v-col applies Vuetify's max-width
   (33.333% from cols="4", 100% from cols="12"). With full-length values that
   cap is narrower than the content, so text overflowed the column and
   overlapped the next one. Remove the cap + the gutter padding so every cell
   sizes to its own content and only the row's column-gap spaces them. */
.history-row > .col {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    /* !important overrides the per-column pl-4 / pt-1 / pb-2 utility classes
       (Vuetify spacing utilities are !important) so every cell shares the same
       padding and the only horizontal spacing is the row's column-gap. */
    padding: 0.25rem 0 0.5rem 0 !important;
}

/* Each field (label - value) sizes to its own content and never shrinks. */
.history-row .d-flex {
    width: max-content;
    white-space: nowrap;
}

.history-row .d-flex > .text-body-2:last-child,
.history-row .d-flex > .my-custom-tooltip {
    white-space: nowrap;
}


/* Vertical trunk segment rendered per anchor level inside a node (see the
   __trunks array built by getRoundTimeline / buildInterviewTimeline). Its
   `left` comes from getConnectorMargin so it lands exactly on the elbow-arrow
   column of the chain it belongs to. */
.history-trunk {
    position: absolute;
    top: -8px;
    /* Must bridge the largest inter-node gap so the line never breaks. Blocks
       that end with a divider (my-6) leave a 24px collapsed margin before the
       next node — reach past it; the overdraw merges invisibly into the next
       node's trunk segment or elbow arm on the same column. */
    bottom: -26px;
    width: 1px;
    background-color: #a3a3a3;
}

/* Dividers hang from a shared column via a negative margin-left that grows with
   the node's nesting depth (see getDividerMargin). Vuetify's `.v-divider`
   caps the box at `max-width: 100%` of the node, so that negative margin can't
   be absorbed by the width — it gets pushed into margin-right instead, pulling
   the right end inward by the same (depth-dependent) amount. Lifting the cap
   lets width solve to `nodeWidth + |margin-left|`, so every divider ends on the
   node's right edge — the same absolute x at every level. */
.history-node > .v-divider {
    max-width: none;
}

.job-role-ellipsis {
    display: inline-block;
    max-width: calc(100% - 4rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
</style>
